import axios from './interceptor';

const EOTM_URL = `${process.env.REACT_APP_BASE_URL}/employee-of-month`;

export function getAwards(params) {
    return axios.get(EOTM_URL, { params });
}

export function getMyRewards() {
    return axios.get(`${EOTM_URL}/my-rewards`);
}

export function createAward(obj) {
    return axios.post(EOTM_URL, obj);
}

export function deleteAward(id) {
    return axios.delete(`${EOTM_URL}/${id}`);
}
